import LoadingVue from './index.vue';
const $loading = {
  install: (Vue) => {
    const LoadingComponent = Vue.extend(LoadingVue);
    const vm = new LoadingComponent();
    const tpl = vm.$mount().$el;
    document.body.appendChild(tpl);
    Vue.prototype.$showLoading = () => {
      vm.showLoading = true;
    };
    Vue.prototype.$hideLoading = () => {
      vm.showLoading = false;
    };
  },
};

export default $loading;
